import { ReactComponent as BurgerOutlineIcon } from 'assets/icons/burger-outline.svg';
import ChangeLanguage from 'components/common/change-language';
import { useSidebarContext } from 'contexts/sidebar';
import { paths } from 'lib/constants/paths';
import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ISidebarContextType } from 'types';

const Sidebar = () => {
    const { t } = useTranslation();
    const { isSidebarOpen, closeSidebar } = useSidebarContext() as ISidebarContextType;

    return (
        <div
            id="sidebar"
            className={cn(
                'lg:hidden fixed top-0 w-[50vw] min-w-[320px] max-w-[440px] h-screen bg-white overflow-auto pt-[70px] pb-10 px-9 z-40',
                isSidebarOpen ? 'right-0' : '-right-[100%]',
            )}
            style={{
                transition: '0.5s right',
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <BurgerOutlineIcon
                className="lg:hidden cursor-pointer ml-auto"
                onClick={closeSidebar}
            />
            <div className="mt-[70px]">
                <Link
                    to={paths.agencies.list}
                    className="py-2 my-2 ml-[29px] w-full block text-txt text-[20px] md:text-[24px] font-medium"
                >
                    {t('general.agencies')}
                </Link>
                <div className="w-full h-[1px] bg-dark-60" />
                <Link
                    to={paths.residentialComplexes.list}
                    className="py-2 my-2 ml-[29px] w-full block text-txt text-[20px] md:text-[24px] font-medium"
                >
                    {t('general.residential-complexes')}
                </Link>
                <div className="w-full h-[1px] bg-dark-60" />
                <Link
                    to={paths.news.list}
                    className="py-2 my-2 ml-[29px] w-full block text-txt text-[20px] md:text-[24px] font-medium"
                >
                    {t('general.news')}
                </Link>
                <div className="w-full h-[1px] bg-dark-60" />
                <div className="flex justify-center mt-8">
                    <ChangeLanguage />
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
